module.exports = __webpack_public_path__ + "static/media/np.b66578a5.svg";